import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import ReactGA from 'react-ga4';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { useEligibility } from '@/context/base-context';
import { Button } from './button';

export default function SideBarBanner() {
	const { isOptOut, setShowOptOutModal } = useEligibility();

	return (
		<div>
			<Swiper
				modules={[Autoplay]}
				loop
				autoplay={{
					delay: 6000,
					disableOnInteraction: false,
				}}
			>
				{/* {isOptOut === false && ( */}
				<SwiperSlide>
					<div className="mb-8 lg:mb-6 relative">
						{/* <Button
							size="small"
							className="absolute top-2 right-2 !px-2 !py-1 !text-[10px]"
							onClick={() => {
								setShowOptOutModal(true);
							}}
						>
							Niet tonen
						</Button> */}
						<Link
							href="https://www.veldsink.nl/helder-onafhankelijk-advies/?utm_source=KKD&utm_medium=website&utm_campaign=HOA"
							target="_blank"
							rel="sponsored"
							onClick={() =>
								ReactGA.event({
									category: 'Sponsored Banner',
									action: 'Click',
									label: 'Veldsink banner click',
								})
							}
						>
							<picture>
								<source
									media="(max-width: 600px)"
									srcSet="https://api.keukenkampioendivisie.nl/wp-content/uploads/2026/08/HOA-KKD-advertentie_350x350.gif"
								/>
								<source
									media="(min-width: 601px) and (max-width: 768px)"
									srcSet="https://api.keukenkampioendivisie.nl/wp-content/uploads/2026/08/HOA-KKD-advertentie_600x300.gif"
								/>
								<source
									media="(min-width: 769px) and (max-width: 1024px)"
									srcSet="https://api.keukenkampioendivisie.nl/wp-content/uploads/2026/08/HOA-KKD-advertentie_769x433.gif"
								/>
								<source
									media="(min-width: 1025px)"
									srcSet="https://api.keukenkampioendivisie.nl/wp-content/uploads/2026/08/HOA-KKD-advertentie_350x350.gif"
								/>
								<img
									src="https://api.keukenkampioendivisie.nl/wp-content/uploads/2026/08/HOA-KKD-advertentie_350x350.gif"
									alt="Default Image"
								/>
							</picture>
						</Link>
					</div>
				</SwiperSlide>
				{/* )} */}
			</Swiper>
		</div>
	);
}
